import React from 'react';
import { useRouter } from 'next/router';
import Layout from '@fuww/library/src/Layout';
import JobSearchPage from '../components/Jobs/JobSearch';
import withApollo from '../lib/apollo';
import profileBySlugEBPQuery
  from '../lib/queries/products/profileBySlugEbpQuery.graphql';
import withQuery from '../lib/withQuery';
import Loader from '../components/Loader';
import {
  profileJobsListImageConfigurations,
  profileJobsListLogoConfigurations,
  profileJobsListMobileImageConfigurations,
} from '../lib/imageConfigurations';
import {
  ProfileBySlugEbpQuery,
  ProfileBySlugEbpQueryVariables,
} from '../lib/graphql/api/graphql';

const JobSearchPageWithQuery = withQuery<
ProfileBySlugEbpQuery,
ProfileBySlugEbpQueryVariables,
true,
{
  field: string | null;
  notFound: boolean | null;
}
>(JobSearchPage, { renderAlways: true });

const CareersPage = () => {
  const { query: { companySlug } } = useRouter();

  return (
    <JobSearchPageWithQuery
      query={profileBySlugEBPQuery}
      variables={{
        slug: companySlug as string,
        imageConfigurations: profileJobsListImageConfigurations,
        mobileImageConfigurations: profileJobsListMobileImageConfigurations,
        logoConfigurations: profileJobsListLogoConfigurations,
      }}
      errorMessage="Error loading jobs"
      loader={<Loader fullScreen />}
      field="profileBySlug"
      notFound={null}
    />
  );
};

CareersPage.getLayout = (page: React.ReactNode) => (
  <Layout layoutMaxWidth="100vw">{page}</Layout>
);

const CareersPageWithApollo = withApollo(CareersPage);

export default CareersPageWithApollo;
